import { Input, Select } from 'react-daisyui'
import { Button } from '@/components/Button.tsx'
import { useClient } from '@/stores/useClient.ts'
import { useState } from 'react'
import { useProfile } from '@/stores/useAuth.ts'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { HeyDriveType } from '@/models/drive.ts'
import { Trans, useTranslation } from 'react-i18next'

export default function ActivatePage() {
  const { t } = useTranslation()
  const { activateDrive } = useClient()
  const [isCreatingDemo, setIsCreatingDemo] = useState(false)
  const [email, setEmail] = useState('')
  const [activationCode, setActivationCode] = useState('')
  const { setAuthenticationToken, setProfile } = useProfile()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)
  const [searchParams] = useSearchParams()
  const [driveType, setDriveType] = useState<HeyDriveType>(searchParams.get('type') as HeyDriveType || HeyDriveType.WEDDING)
  const country: string | undefined = searchParams.get('c') || undefined
  const language: string | undefined = searchParams.get('l') || undefined

  async function onSubmit(e: any) {
    e.preventDefault()
    e.stopPropagation()

    if (isCreatingDemo) {
      return
    }

    setIsCreatingDemo(true)

    try {
      const res = await activateDrive(email, activationCode, driveType, country, language)
      setProfile(res.data.profile)
      setAuthenticationToken(res.headers['ha-token'])

      const driveId = res.data.drive
      navigate(`/d/${driveId}`)
    } catch (e: any) {
      console.error('Demo Error', e)
      if (e.response) {
        if (e.response.status === 400) {
          if (e.response.data && e.response.data.includes('invalid_data') && e.response.data.includes('email')) {
            setError(t('demo.invalidEmail'))
          }
          if (e.response.data && e.response.data === 'invalid code') {
            setError(t('activate.activationCodeNotFound'))
          }
          if (e.response.data && e.response.data === 'email taken') {
            setError(t('demo.emailAlreadyUsed'))
          }
          console.log('data', e.response.data)
        }
      }
      // alert('Error creating demo: ' + JSON.stringify(e.response))
    } finally {
      setIsCreatingDemo(false)
    }
  }

  // @ts-ignore
  const driveTypeImage = {
    [HeyDriveType.BIRTHDAY]: '/demoX/app-screenshot-geburtstag.jpeg',
    [HeyDriveType.COMPANY]: '/demoX/app-screenshot-firmenfeier.jpeg',
  }[driveType] || '/demoX/app-screenshot-hochzeit.jpeg'

  return <div className='bg-cover bg-top h-full' style={{ backgroundImage: `url(${driveTypeImage})` }}>
    <div className="w-full h-full bg-[black] bg-opacity-40">
      <div className='w-full h-full flex items-center justify-center'>
        <div className='bg-neutral p-4 m-3 rounded-xl text-center flex flex-col gap-4 shadow'>
          <h1 className='text-xl font-semibold'>{t('activate.activation')}</h1>
          <p>{t('activate.enterActivationCodeAndEmail')}</p>
          <form onSubmit={onSubmit} className='flex flex-col gap-5'>
            <Input placeholder={t('activate.activationCodePlaceholder')} required value={activationCode} onChange={e => setActivationCode(e.target.value)} />
            <Input placeholder={t('common.yourEmail')} required value={email} onChange={e => setEmail(e.target.value)} />
            <Select value={driveType} onChange={e => setDriveType(e.currentTarget.value as HeyDriveType)}>
              <Select.Option value={HeyDriveType.WEDDING}>{t('common.wedding')}</Select.Option>
              <Select.Option value={HeyDriveType.BIRTHDAY}>{t('common.birthday')}</Select.Option>
            </Select>
            { error && <p className='text-error text-sm'>{ error }</p> }
            <div>
              <Button color='primary' className=''>
                {t('activate.activate')}
              </Button>
            </div>
          </form>
          <p className='text-sm opacity-50 max-w-[20rem] text-center mx-auto'>
            <Trans i18nKey='activate.registrationAgreement'>
              <a className='underline' href="https://fridaysnap.de/datenschutzerklaerung/" />
            </Trans>
          </p>
        </div>
        {/*<div className="container mx-auto bg-primary">*/}
        {/*  snrtnrt*/}
        {/*</div>*/}
      </div>
    </div>
  </div>
}
